import { useLoaderData, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { getAddSerie } from "../../api/Get";
import { postAddSerie } from "../../api/Post";
import FormSerie from "./FormSerie";

const addSerieLoader = async () => {
  const details = await getAddSerie();
  return details;
};

const AddSerie = () => {
  const navigate = useNavigate();
  const { collections } = useLoaderData();
  const { state } = useLocation();

  const [errorMsg, setErrorMsg] = useState("");

  const onFinish = async (values) => {
    const res = await postAddSerie(values);
    console.log(res);
    if (res.error) setErrorMsg(res.error);
    else
      navigate(`/serie/add/episode`, {
        state: { serie: res.serie, seasons: [res.season] },
      });
  };

  return (
    <>
      <FormSerie
        title={"Ajouter une série"}
        type={"add"}
        onFinish={onFinish}
        initialValues={{
          serieState: "admin",
          collectionName: state?.collectionName || null,
        }}
        collections={collections}
        errorMsg={errorMsg}
      />
    </>
  );
};

export { AddSerie, addSerieLoader };
